import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { FaChartLine, FaLayerGroup, FaPlug } from "react-icons/fa6";

const ACCENT = "#04aec1";
const ACCENT_MID = "#6366f1";

const CARDS = [
  {
    icon: FaPlug,
    title: "Connect",
    body: "Plug into Pick n Pay, Checkers, Dis-Chem, Clicks, Makro and more — no IT project required.",
  },
  {
    icon: FaLayerGroup,
    title: "Consolidate",
    body: "We normalize SKUs, store codes and metrics across retailers so you stop comparing apples to oranges.",
  },
  {
    icon: FaChartLine,
    title: "Decide",
    body: "Live dashboards, alerts, and forecasts you can hand to a buyer or a board on the same day.",
  },
];

const Card = ({ icon: Icon, title, body }) => (
  <Box
    bg="white"
    borderRadius="20px"
    p="28px"
    border="1px solid rgba(15,22,38,0.06)"
    boxShadow="0 12px 30px -16px rgba(15,22,38,0.10)"
    transition="transform .25s ease, box-shadow .25s ease"
    _hover={{
      transform: "translateY(-4px)",
      boxShadow: "0 18px 40px -18px rgba(15,22,38,0.18)",
    }}
  >
    <Box
      w="44px"
      h="44px"
      borderRadius="12px"
      bg={`linear-gradient(135deg, ${ACCENT}, ${ACCENT_MID})`}
      display="grid"
      placeItems="center"
      color="white"
      fontSize="16px"
      mb="16px"
      boxShadow={`0 8px 18px -8px ${ACCENT}99`}
    >
      <Icon />
    </Box>
    <Heading
      as="h3"
      m={0}
      fontSize="18px"
      fontWeight={700}
      letterSpacing="-0.01em"
      color="#0a0e1a"
    >
      {title}
    </Heading>
    <Text
      mt="8px"
      mb={0}
      fontSize="14px"
      color="rgba(15,22,38,0.65)"
      lineHeight="1.55"
    >
      {body}
    </Text>
  </Box>
);

const AboutWhatWeDo = () => (
  <Box
    as="section"
    bg="#f7fafc"
    px={{ base: "20px", md: "28px" }}
    py={{ base: "64px", md: "96px" }}
  >
    <Box maxW="1280px" mx="auto">
      <Box
        textAlign="center"
        maxW="720px"
        mx="auto"
        mb={{ base: "40px", md: "56px" }}
      >
        <Text
          as="span"
          display="inline-block"
          fontSize="11px"
          fontWeight={700}
          letterSpacing="0.16em"
          textTransform="uppercase"
          color={ACCENT}
          mb="14px"
        >
          What we do
        </Text>
        <Heading
          as="h2"
          m={0}
          fontSize={{ base: "30px", md: "40px" }}
          fontWeight={700}
          letterSpacing="-0.025em"
          lineHeight="1.15"
          color="#0a0e1a"
        >
          One dashboard, every retailer feed, daily.
        </Heading>
        <Text
          mt="14px"
          mb={0}
          fontSize="16px"
          color="rgba(15,22,38,0.65)"
          lineHeight="1.55"
        >
          We connect to the major South African and African retailer portals,
          normalize the data, and surface what matters most: sales, strike
          rates, on-shelf availability, and forecasts.
        </Text>
      </Box>

      <Grid
        templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
        gap="18px"
      >
        {CARDS.map((c) => (
          <Card key={c.title} {...c} />
        ))}
      </Grid>
    </Box>
  </Box>
);

export default AboutWhatWeDo;
